
export default function StrengthSection() {
  const facilities = [
    {
      title: '检测中心',
      subtitle: '年份茶专利技术 + 古树茶认证',
      image: 'https://public.readdy.ai/ai/img_res/ed98878a5bc6477bb6d689d5f7fb19db.jpg',
      features: ['专利年份检测技术', '古树茶DNA认证', '营养成分分析', '重金属检测']
    },
    {
      title: '智能化仓储',
      subtitle: '温湿度智能监控 + 自动化管理',
      image: 'https://readdy.ai/api/search-image?query=Massive%20modern%20warehouse%20with%20automated%20storage%20systems%20for%20tea%2C%20intelligent%20climate%20control%20displays%20showing%20temperature%20and%20humidity%20monitoring%2C%20robotic%20systems%20managing%20tea%20inventory%2C%20high-tech%20storage%20facility%2C%20professional%20lighting%2C%20organized%20tea%20storage%20areas%2C%20futuristic%20warehouse%20design%2C%20clean%20industrial%20environment&width=600&height=400&seq=smart-warehouse&orientation=landscape',
      features: ['恒温恒湿存储', '智能监控系统', '自动化分拣', '防伪追溯']
    },
    {
      title: '溯源研究院',
      subtitle: '山头茶数据库 + 产地认证',
      image: 'https://readdy.ai/api/search-image?query=High-tech%20tea%20research%20institute%20with%20large%20digital%20displays%20showing%20tea%20origin%20data%20maps%2C%20researchers%20analyzing%20tea%20samples%2C%20computer%20screens%20displaying%20detailed%20tea%20mountain%20databases%2C%20professional%20research%20environment%2C%20modern%20technology%20meets%20traditional%20tea%20culture%2C%20data%20visualization%20systems%2C%20clean%20scientific%20workspace&width=600&height=400&seq=research-institute&orientation=landscape',
      features: ['产地数字化建档', '茶山GPS定位', '生长环境记录', '采摘工艺追踪']
    }
  ];

  return (
    <section id="strength" className="py-20 bg-white">
      <div className="container mx-auto px-6 lg:px-16 xl:px-24">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-800 mb-4">
            为什么选择南滇？
          </h2>
          <p className="text-base md:text-xl text-gray-600 max-w-3xl mx-auto">
            专业的基础设施 · 完善的质量体系 · 全面的技术支持
          </p>
        </div>

        {/* Video intro */}
        <div className="mb-16 max-w-4xl mx-auto">
          <div className="relative rounded-2xl overflow-hidden shadow-2xl">
            <img
              src="https://readdy.ai/api/search-image?query=Professional%20documentary-style%20video%20thumbnail%20showing%20the%20complete%20tea%20supply%20chain%20process%20from%20ancient%20tea%20mountains%20to%20modern%20processing%20facilities%2C%20split-screen%20showing%20traditional%20tea%20picking%20and%20modern%20warehouse%20operations%2C%20cinematic%20quality%2C%20professional%20video%20production%20style%2C%20play%20button%20overlay%2C%20high-quality%20production%20values&width=800&height=450&seq=video-thumb&orientation=landscape"
              alt="品牌纪录片"
              className="w-full h-64 md:h-96 object-cover"
            />
            <div className="absolute inset-0 bg-black/30 flex items-center justify-center">
              <button className="w-20 h-20 bg-white/90 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-white transition-all duration-300 hover:scale-110 cursor-pointer">
                <i className="ri-play-fill text-blue-600 text-3xl ml-1"></i>
              </button>
            </div>
            <div className="absolute bottom-4 left-4 text-white">
              <h3 className="text-base md:text-xl font-bold mb-1">南滇古茶品牌纪录片</h3>
              <p className="text-sm md:text-base text-white/80">3分钟了解完整供应链体系</p>
            </div>
          </div>
        </div>

        {/* Facilities */}
        <div className="space-y-12">
          {facilities.map((facility, index) => (
            <div
              key={index}
              className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} items-center gap-8 lg:gap-12`}
            >
              <div className="flex-1">
                <img
                  src={facility.image}
                  alt={facility.title}
                  className="w-full h-80 object-cover rounded-2xl shadow-lg"
                />
              </div>
              <div className="flex-1 space-y-6">
                <div>
                  <h3 className="text-xl md:text-2xl lg:text-3xl font-bold text-gray-800 mb-2">
                    {facility.title}
                  </h3>
                  <p className="text-base md:text-lg text-blue-600 font-medium">
                    {facility.subtitle}
                  </p>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  {facility.features.map((feature, featureIndex) => (
                    <div
                      key={featureIndex}
                      className="flex items-center space-x-3 p-3 bg-blue-50 rounded-lg"
                    >
                      <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
                      <span className="text-sm md:text-base text-gray-700 font-medium">{feature}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Honor wall */}
        <div className="mt-16 text-center">
          <h3 className="text-xl md:text-2xl font-bold text-gray-800 mb-8">荣誉墙</h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {[
              '发明专利证书',
              '行业合作授牌',
              '质量认证证书',
              '技术创新奖'
            ].map((honor, index) => (
              <div
                key={index}
                className="bg-gradient-to-br from-blue-50 to-blue-100 p-6 rounded-xl border border-blue-200 hover:shadow-lg transition-all duration-300"
              >
                <div className="w-16 h-16 mx-auto mb-4 bg-gradient-to-r from-blue-400 to-blue-500 rounded-full flex items-center justify-center">
                  <i className="ri-award-line text-white text-2xl"></i>
                </div>
                <h4 className="text-sm md:text-base font-bold text-gray-800">{honor}</h4>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
